























import { Component, Vue, Prop } from 'vue-property-decorator';

import DateUtils from '@/utils/DateUtils';

import AdminService from '@/api/AdminService';

@Component({})
export default class CustomerRecentActivity extends Vue {
  @Prop(String) customerId!: string;

  adminService: AdminService = new AdminService();

  activities: Record<string, any>[] = [];
  loading: boolean = true;
  next: string = '';

  async getActivities() {
    this.loading = true;
    const { data } = await this.adminService.getCustomerActivities(
      this.customerId,
      this.next
    );

    const prepareData = data.items.map((activity: any) => ({
      ...activity,
      time: DateUtils.formatISOLongDate(activity.createdAt, true)
    }));

    this.activities = [...this.activities, ...prepareData];
    this.next = data.links.next;
    this.loading = false;
  }

  createObserver() {
    const target = this.$refs.target as HTMLElement;

    const observer = new IntersectionObserver(async entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting && this.next !== null) {
          this.getActivities();
        }
      });
    });

    if (target) {
      observer.observe(target);
    }
  }

  async mounted() {
    await this.getActivities();

    this.$nextTick(function() {
      this.createObserver();
    });
  }
}
